import { useCallback, useEffect, useRef, useState } from "react";

/** Trailing-edge debounce for search inputs. */
export function useDebounced(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

/** Debounced callback with a stable identity (used for the settings autosave). */
export function useDebouncedCallback(callback, delay = 500) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return useCallback(
    (...args) => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => callbackRef.current(...args), delay);
    },
    [delay],
  );
}
